import React from 'react';
import Topbar from './Topbar';
import Footer from './Footer';
import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

// function to take table and forward next based on value of table
function forwardNext (table) {
    if (table === 'application') {
        return '/uploadresume'
    } 
    if (table === 'service_request') {
        console.log('Forwarding to thank you page')
        return '/thankyou'
    }
    if (table === 'idea_registration') {
        return '/thankyou'
    }
    if (table === 'email_list') {
        return '/emailadded'
    }
}

export default function InputCode() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    const { table } = useParams();
    const digit1Ref = useRef(null);
    const digit2Ref = useRef(null);
    const digit3Ref = useRef(null);
    const digit4Ref = useRef(null);
    const digit5Ref = useRef(null);
    const digit6Ref = useRef(null);
    
    const handleInputChange = (e, nextRef) => {
        if (e.target.value.length === 1 && nextRef) {
          nextRef.current.focus();
        }
    };
    
    async function handleSubmit(event) {
        setIsSubmitting(true); // Disable the button and show the spinner
        event.preventDefault()
        const code = [
            digit1Ref.current.value,
            digit2Ref.current.value,
            digit3Ref.current.value,
            digit4Ref.current.value,
            digit5Ref.current.value,
            digit6Ref.current.value,
          ].join('');
        console.log(code)

        fetch('https://binaryinventions.com/api/verify_email', {
            method: 'POST',
            headers: {        
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code: code, table: table}),
        })
            .then((data) => {
                console.log('Success:', data)
                window.location.href = forwardNext(table)
            })
            .catch((error) => {
                console.error('Error:', error)
            }).finally(() => {
                setIsSubmitting(false); // Enable the button and hide the spinner
            })
    }
    
    return (
        <div>
            <Topbar />
            <div className="bg-white py-16 sm:py-24 lg:py-32">
                <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 lg:grid-cols-12 lg:gap-8 lg:px-8">
                    <h2 className="max-w-xl text-balance text-2xl font-semibold tracking-tight text-gray-900 sm:text-4xl lg:col-span-7">
                        Verify your email address
                    </h2>
                    <h5 className="italic text-gray-500 lg:col-span-7">
                        Check the email you input on the previous application form for the six digit code
                    </h5>
                    <form className="w-full max-w-md lg:col-span-5 lg:pt-2" onSubmit={handleSubmit}>
                        <div className="flex gap-x-4">
                            <label htmlFor="digit-1" className="sr-only">
                                Digit 1
                            </label>
                            <input
                                id="digit-1"
                                name="digit-1"
                                type="text"
                                maxLength={1}
                                ref={digit1Ref}
                                onChange={(e) => handleInputChange(e, digit2Ref)}
                                required
                                autoComplete="off"
                                className="min-w-0 flex-auto rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-ind
igo-600 sm:text-sm/6"
                            />
                            <label htmlFor="digit-2" className="sr-only">
                                Digit 2
                            </label>
                            <input
                                id="digit-2"
                                name="digit-2"
                                type="text"
                                maxLength={1}
                                ref={digit2Ref}
                                onChange={(e) => handleInputChange(e, digit3Ref)}
                                required
                                autoComplete="off"
                                className="min-w-0 flex-auto rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-ind
igo-600 sm:text-sm/6"
                            />
                            <label htmlFor="digit-3" className="sr-only">
                                Digit 3
                            </label>
                            <input
                                id="digit-3"
                                name="digit-3"
                                type="text"
                                maxLength={1}
                                ref={digit3Ref}
                                onChange={(e) => handleInputChange(e, digit4Ref)}
                                required
                                autoComplete="off"
                                className="min-w-0 flex-auto rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-ind
igo-600 sm:text-sm/6"
                            />
                            <label htmlFor="digit-4" className="sr-only">
                                Digit 4
                            </label>
                            <input
                                id="digit-4"
                                name="digit-4"
                                type="text"
                                maxLength={1}
                                ref={digit4Ref}
                                onChange={(e) => handleInputChange(e, digit5Ref)}
                                required
                                autoComplete="off"
                                className="min-w-0 flex-auto rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-ind
igo-600 sm:text-sm/6"
                            />
                            <label htmlFor="digit-5" className="sr-only">
                                Digit 5
                            </label>
                            <input
                                id="digit-5"
                                name="digit-5"
                                type="text"
                                maxLength={1}
                                ref={digit5Ref}
                                onChange={(e) => handleInputChange(e, digit6Ref)}
                                required
                                autoComplete="off"
                                className="min-w-0 flex-auto rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-ind
igo-600 sm:text-sm/6"
                            />
                            <label htmlFor="digit-6" className="sr-only">
                                Digit 6
                            </label>
                            <input
                                id="digit-6"
                                name="digit-6"
                                type="text"
                                maxLength={1}
                                ref={digit6Ref}
                                onChange={(e) => handleInputChange(e)}
                                required
                                autoComplete="off"
                                className="min-w-0 flex-auto rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-ind
igo-600 sm:text-sm/6"
                            />
                        </div>
                        <div className="flex justify-between items-center mt-4">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`flex-none rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm ${
                                isSubmitting
                                ? 'bg-gray-400 cursor-not-allowed'
                                : 'bg-gray-600 hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                            }`}
                            >
                            <div className="flex items-center gap-2">
                                {isSubmitting && (
                                <svg
                                    className="animate-spin h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    ></circle>
                                    <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                    ></path>
                                </svg>
                                )}
                                Submit
                            </div>
                        </button>
                        </div>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    )   

}